import _regeneratorRuntime from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright 2019-2021 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { assert, stringToU8a, u8aToString } from '@polkadot/util';
var wasm = null;
var cachegetInt32 = null;
var cachegetUint8 = null;
export function initWasm(_x, _x2, _x3) {
  return _initWasm.apply(this, arguments);
} // FIXME We really would love to clean this up and have a sign like (wasm, ...params) => T
// Alas, TypeScript foo is not that great today, so we sadly have an extra closure here

function _initWasm() {
  _initWasm = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(wasmBytes, asmFn, wbg) {
    var source;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            assert(typeof WebAssembly !== 'undefined' && wasmBytes && wasmBytes.length, 'WebAssembly is not available in your environment');
            _context.next = 4;
            return WebAssembly.instantiate(wasmBytes, {
              wbg: wbg
            });

          case 4:
            source = _context.sent;
            wasm = source.instance.exports;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            // if we have a valid supplied asm.js, return that
            if (asmFn) {
              wasm = asmFn(wbg);
            } else {
              console.error('FATAL: Unable to initialize @polkadot/wasm-crypto');
              console.error(_context.t0);
              wasm = null;
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _initWasm.apply(this, arguments);
}

export function withWasm(fn) {
  return function () {
    assert(wasm, 'The WASM interface has not been initialized. Ensure that you wait for the initialization Promise with waitReady() from @polkadot/wasm-crypto (or cryptoWaitReady() from @polkadot/util-crypto) before attempting to use WASM-only interfaces.');
    return fn(wasm).apply(void 0, arguments);
  };
}
export function getWasm() {
  return wasm;
}
export function getInt32() {
  if (cachegetInt32 === null || cachegetInt32.buffer !== wasm.memory.buffer) {
    cachegetInt32 = new Int32Array(wasm.memory.buffer);
  }

  return cachegetInt32;
}
export function getUint8() {
  if (cachegetUint8 === null || cachegetUint8.buffer !== wasm.memory.buffer) {
    cachegetUint8 = new Uint8Array(wasm.memory.buffer);
  }

  return cachegetUint8;
}
export function getU8a(ptr, len) {
  return getUint8().subarray(ptr / 1, ptr / 1 + len);
}
export function getString(ptr, len) {
  return u8aToString(getU8a(ptr, len));
}
export function allocU8a(arg) {
  var ptr = wasm.__wbindgen_malloc(arg.length * 1);

  getUint8().set(arg, ptr / 1);
  return [ptr, arg.length];
}
export function allocString(arg) {
  return allocU8a(stringToU8a(arg));
}
export function resultU8a() {
  var r0 = getInt32()[8 / 4 + 0];
  var r1 = getInt32()[8 / 4 + 1];
  var ret = getU8a(r0, r1).slice();

  wasm.__wbindgen_free(r0, r1 * 1);

  return ret;
}
export function resultString() {
  return u8aToString(resultU8a());
}